import { Link } from 'react-router-dom';
import apiConfig from '../config/api';
import { getHikeDay } from '../utils/dateUtils';
import styles from './UpdateCard.module.css';

// Truncate HTML content to specific character length
const truncateHtml = (html, maxLength) => {
  if (!html) return '';
  
  // Create temporary div to parse HTML
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  const textContent = tempDiv.textContent || tempDiv.innerText || '';
  
  if (textContent.length <= maxLength) return html;
  
  return textContent.substring(0, maxLength) + '...';
};

// Format date to YYYY-MM-DD in PDT timezone
const formatDate = (dateString) => {
  const date = new Date(dateString);
  
  // Format date in PDT/PST (Pacific Time)
  const options = { 
    year: 'numeric', 
    month: '2-digit', 
    day: '2-digit',
    timeZone: 'America/Los_Angeles' 
  };
  
  const formatted = new Intl.DateTimeFormat('en-US', options).format(date);
  // Convert from MM/DD/YYYY to YYYY-MM-DD format
  const [month, day, year] = formatted.split('/');
  return `${year}-${month}-${day}`;
};

const UpdateCard = ({ post, showDate = false, className = '' }) => {
  return (
    <div className={`${styles.updateCard} ${className}`}>
      <Link to={`/posts/${post._id}`} className={styles.updateLink}>
        <div className={styles.updateHeader}>
          <span className={styles.updateMile}>Mile {post.mile}</span>
          {showDate && (
            <span className={styles.updateDate}>
              {formatDate(post.time)}
            </span>
          )}
        </div>
        <h3 className={styles.locationName}>
          Day {getHikeDay(post.time)}
          {post.title && `: ${post.title}`}
        </h3>
        <div 
          className={styles.updateText}
          dangerouslySetInnerHTML={{ __html: truncateHtml(post.text, 200) }}
        />
        {post.photoUrls && post.photoUrls.length > 0 && (
          <div className={styles.photoGrid}>
            {post.photoUrls.slice(0, 4).map((photoUrl, index) => {
              const thumbnailUrl = post.thumbnailUrls?.[index] ?? photoUrl;
              const fallbackUrl = `${apiConfig.baseUrl}${photoUrl}`;
              return (
                <img
                  key={index}
                  src={`${apiConfig.baseUrl}${thumbnailUrl}`}
                  alt={`Photo from day ${getHikeDay(post.time)}`}
                  className={styles.updatePhoto}
                  loading="lazy"
                  width="256"
                  height="256"
                  onError={(e) => {
                    if (e.currentTarget.src !== fallbackUrl) {
                      e.currentTarget.src = fallbackUrl;
                    }
                  }}
                />
              );
            })}
          </div>
        )}
      </Link>
    </div>
  );
};

export default UpdateCard; 